const getVideoProcessingLabelKey = ({ hasError, isSlow }) => {
  if (hasError) return 'videoProcessingFailed';
  if (isSlow) return 'videoProcessingSlow';
  return 'videoProcessing';
};

export default getVideoProcessingLabelKey;
